import React from 'react'
import LabeledSelect from './LabeledSelect'
import { debounce, isEmpty } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { requestProductSearch } from '../../redux/sagas/requests/searchService'
import { getProductInfoById } from '../../redux/sagas/requests/productService'

const ProductSearchSelect = React.memo(
  ({
    label,
    value,
    onChange,
    placeholder = 'Search for Products',
    hasVariant = true,
    emptyMsg = 'No data',
    extData,
    ...props
  }) => {
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      if (extData && !value && onChange && !loading) {
        setLoading(true)
        getProductInfoById(extData).then((response) => {
          onChange(response.data)
        })
        setLoading(false)
      }
    }, [extData])

    // noinspection JSCheckFunctionSignatures
    const debouncedSearchProduct = useCallback(
      debounce((inputText, callback) => {
        handleSearchProduct(inputText, hasVariant).then((options) =>
          callback(options),
        )
      }, 500),
      [],
    )

    return (
      <LabeledSelect
        label={label}
        value={value}
        getOptionLabel={(option) =>
          hasVariant
            ? `${option?.label}\n
      ${option?.variant_values
              ? Object.entries(option?.variant_values)
                .map(([key, value]) => `${key}: ${value}`)
                .join(' ')
              : ''
            }`
            : `${option.label}`
        }
        getOptionValue={(option) => option.item}
        placeholder={placeholder}
        onChange={onChange}
        emptyMsg={emptyMsg}
        {...props}
        loadOptions={debouncedSearchProduct}
      />
    )
  },
)

export default ProductSearchSelect

const handleSearchProduct = (input, hasVariant) => {
  if (isEmpty(input)) {
    return []
  }
  return requestProductSearch(input, hasVariant).then((response) =>
    response.data ? response.data : [],
  )
}
